export default {
  "03/07/2019": {
    "data": [
      {
        "id": 39657,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 3",
        "sales_channel": "all",
        "sold_out_percentage": 1.19,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39660,
        "name": "VIP",
        "event_name": "Cannabition - Jul 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63747
  },
  "04/07/2019": {
    "data": [
      {
        "id": 39663,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39666,
        "name": "VIP",
        "event_name": "Cannabition - Jul 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63750
  },
  "05/07/2019": {
    "data": [
      {
        "id": 39669,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39672,
        "name": "VIP",
        "event_name": "Cannabition - Jul 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63753
  },
  "06/07/2019": {
    "data": [
      {
        "id": 39675,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39678,
        "name": "VIP",
        "event_name": "Cannabition - Jul 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63756
  },
  "07/07/2019": {
    "data": [
      {
        "id": 39687,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 7",
        "sales_channel": "all",
        "sold_out_percentage": 0.48,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39690,
        "name": "VIP",
        "event_name": "Cannabition - Jul 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63762
  },
  "08/07/2019": {
    "data": [
      {
        "id": 39693,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39696,
        "name": "VIP",
        "event_name": "Cannabition - Jul 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63765
  },
  "09/07/2019": {
    "data": [
      {
        "id": 39681,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39684,
        "name": "VIP",
        "event_name": "Cannabition - Jul 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63759
  },
  "10/07/2019": {
    "data": [
      {
        "id": 39699,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39702,
        "name": "VIP",
        "event_name": "Cannabition - Jul 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63768
  },
  "11/07/2019": {
    "data": [
      {
        "id": 39705,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39708,
        "name": "VIP",
        "event_name": "Cannabition - Jul 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63771
  },
  "12/07/2019": {
    "data": [
      {
        "id": 39711,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39714,
        "name": "VIP",
        "event_name": "Cannabition - Jul 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63774
  },
  "13/07/2019": {
    "data": [
      {
        "id": 39717,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39720,
        "name": "VIP",
        "event_name": "Cannabition - Jul 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63777
  },
  "14/07/2019": {
    "data": [
      {
        "id": 39723,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39726,
        "name": "VIP",
        "event_name": "Cannabition - Jul 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63780
  },
  "15/07/2019": {
    "data": [
      {
        "id": 39729,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39732,
        "name": "VIP",
        "event_name": "Cannabition - Jul 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63783
  },
  "16/07/2019": {
    "data": [
      {
        "id": 39735,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39738,
        "name": "VIP",
        "event_name": "Cannabition - Jul 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63786
  },
  "17/07/2019": {
    "data": [
      {
        "id": 39741,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39744,
        "name": "VIP",
        "event_name": "Cannabition - Jul 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63789
  },
  "18/07/2019": {
    "data": [
      {
        "id": 39747,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39750,
        "name": "VIP",
        "event_name": "Cannabition - Jul 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63792
  },
  "19/07/2019": {
    "data": [
      {
        "id": 39753,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39756,
        "name": "VIP",
        "event_name": "Cannabition - Jul 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63795
  },
  "20/07/2019": {
    "data": [
      {
        "id": 39759,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39762,
        "name": "VIP",
        "event_name": "Cannabition - Jul 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63798
  },
  "21/07/2019": {
    "data": [
      {
        "id": 39765,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39768,
        "name": "VIP",
        "event_name": "Cannabition - Jul 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63801
  },
  "22/07/2019": {
    "data": [
      {
        "id": 39771,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39774,
        "name": "VIP",
        "event_name": "Cannabition - Jul 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63804
  },
  "23/07/2019": {
    "data": [
      {
        "id": 39777,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39780,
        "name": "VIP",
        "event_name": "Cannabition - Jul 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63807
  },
  "24/07/2019": {
    "data": [
      {
        "id": 39783,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39786,
        "name": "VIP",
        "event_name": "Cannabition - Jul 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63810
  },
  "25/07/2019": {
    "data": [
      {
        "id": 39789,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39792,
        "name": "VIP",
        "event_name": "Cannabition - Jul 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63813
  },
  "26/07/2019": {
    "data": [
      {
        "id": 39795,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39798,
        "name": "VIP",
        "event_name": "Cannabition - Jul 26",
        "sales_channel": "all",
        "sold_out_percentage": 3.75,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63816
  },
  "27/07/2019": {
    "data": [
      {
        "id": 39801,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39804,
        "name": "VIP",
        "event_name": "Cannabition - Jul 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63819
  },
  "28/07/2019": {
    "data": [
      {
        "id": 39807,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39810,
        "name": "VIP",
        "event_name": "Cannabition - Jul 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63822
  },
  "29/07/2019": {
    "data": [
      {
        "id": 39813,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39816,
        "name": "VIP",
        "event_name": "Cannabition - Jul 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63825
  },
  "30/07/2019": {
    "data": [
      {
        "id": 39819,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39822,
        "name": "VIP",
        "event_name": "Cannabition - Jul 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63828
  },
  "31/07/2019": {
    "data": [
      {
        "id": 39825,
        "name": "General Admission",
        "event_name": "Cannabition - Jul 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 39828,
        "name": "VIP",
        "event_name": "Cannabition - Jul 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 63831
  },
  "01/08/2019": {
    "data": [
      {
        "id": 40050,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40053,
        "name": "VIP",
        "event_name": "Cannabition - Aug 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64338
  },
  "02/08/2019": {
    "data": [
      {
        "id": 40056,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40059,
        "name": "VIP",
        "event_name": "Cannabition - Aug 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64341
  },
  "03/08/2019": {
    "data": [
      {
        "id": 40062,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 3",
        "sales_channel": "all",
        "sold_out_percentage": 1.9,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40065,
        "name": "VIP",
        "event_name": "Cannabition - Aug 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64344
  },
  "04/08/2019": {
    "data": [
      {
        "id": 40068,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40071,
        "name": "VIP",
        "event_name": "Cannabition - Aug 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64347
  },
  "05/08/2019": {
    "data": [
      {
        "id": 40074,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40077,
        "name": "VIP",
        "event_name": "Cannabition - Aug 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64350
  },
  "06/08/2019": {
    "data": [
      {
        "id": 40080,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40083,
        "name": "VIP",
        "event_name": "Cannabition - Aug 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64353
  },
  "07/08/2019": {
    "data": [
      {
        "id": 40086,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40089,
        "name": "VIP",
        "event_name": "Cannabition - Aug 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64356
  },
  "08/08/2019": {
    "data": [
      {
        "id": 40092,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40095,
        "name": "VIP",
        "event_name": "Cannabition - Aug 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64359
  },
  "09/08/2019": {
    "data": [
      {
        "id": 40098,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40101,
        "name": "VIP",
        "event_name": "Cannabition - Aug 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64362
  },
  "10/08/2019": {
    "data": [
      {
        "id": 40104,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40107,
        "name": "VIP",
        "event_name": "Cannabition - Aug 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64365
  },
  "11/08/2019": {
    "data": [
      {
        "id": 40110,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40113,
        "name": "VIP",
        "event_name": "Cannabition - Aug 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64368
  },
  "12/08/2019": {
    "data": [
      {
        "id": 40116,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40119,
        "name": "VIP",
        "event_name": "Cannabition - Aug 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64371
  },
  "13/08/2019": {
    "data": [
      {
        "id": 40122,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40125,
        "name": "VIP",
        "event_name": "Cannabition - Aug 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64374
  },
  "14/08/2019": {
    "data": [
      {
        "id": 40128,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40131,
        "name": "VIP",
        "event_name": "Cannabition - Aug 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64377
  },
  "15/08/2019": {
    "data": [
      {
        "id": 40134,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 15",
        "sales_channel": "all",
        "sold_out_percentage": 0.24,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40137,
        "name": "VIP",
        "event_name": "Cannabition - Aug 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64380
  },
  "16/08/2019": {
    "data": [
      {
        "id": 40140,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40143,
        "name": "VIP",
        "event_name": "Cannabition - Aug 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64383
  },
  "17/08/2019": {
    "data": [
      {
        "id": 40146,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40149,
        "name": "VIP",
        "event_name": "Cannabition - Aug 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64386
  },
  "18/08/2019": {
    "data": [
      {
        "id": 40152,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40155,
        "name": "VIP",
        "event_name": "Cannabition - Aug 18",
        "sales_channel": "all",
        "sold_out_percentage": 2.5,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64389
  },
  "19/08/2019": {
    "data": [
      {
        "id": 40158,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40161,
        "name": "VIP",
        "event_name": "Cannabition - Aug 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64392
  },
  "20/08/2019": {
    "data": [
      {
        "id": 40170,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40173,
        "name": "VIP",
        "event_name": "Cannabition - Aug 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64398
  },
  "23/08/2019": {
    "data": [
      {
        "id": 40182,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40185,
        "name": "VIP",
        "event_name": "Cannabition - Aug 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64404
  },
  "24/08/2019": {
    "data": [
      {
        "id": 40188,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40191,
        "name": "VIP",
        "event_name": "Cannabition - Aug 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64407
  },
  "25/08/2019": {
    "data": [
      {
        "id": 40194,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40197,
        "name": "VIP",
        "event_name": "Cannabition - Aug 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64410
  },
  "26/08/2019": {
    "data": [
      {
        "id": 40200,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40203,
        "name": "VIP",
        "event_name": "Cannabition - Aug 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64413
  },
  "27/08/2019": {
    "data": [
      {
        "id": 40206,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40209,
        "name": "VIP",
        "event_name": "Cannabition - Aug 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64416
  },
  "28/08/2019": {
    "data": [
      {
        "id": 40212,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40215,
        "name": "VIP",
        "event_name": "Cannabition - Aug 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64419
  },
  "29/08/2019": {
    "data": [
      {
        "id": 40218,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40221,
        "name": "VIP",
        "event_name": "Cannabition - Aug 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64422
  },
  "30/08/2019": {
    "data": [
      {
        "id": 40224,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40227,
        "name": "VIP",
        "event_name": "Cannabition - Aug 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64425
  },
  "31/08/2019": {
    "data": [
      {
        "id": 40230,
        "name": "General Admission",
        "event_name": "Cannabition - Aug 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40233,
        "name": "VIP",
        "event_name": "Cannabition - Aug 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64428
  },
  "01/09/2019": {
    "data": [
      {
        "id": 40236,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40239,
        "name": "VIP",
        "event_name": "Cannabition - Sep 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64431
  },
  "02/09/2019": {
    "data": [
      {
        "id": 40242,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40245,
        "name": "VIP",
        "event_name": "Cannabition - Sep 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64434
  },
  "03/09/2019": {
    "data": [
      {
        "id": 40248,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40251,
        "name": "VIP",
        "event_name": "Cannabition - Sep 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64437
  },
  "04/09/2019": {
    "data": [
      {
        "id": 40254,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40257,
        "name": "VIP",
        "event_name": "Cannabition - Sep 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64440
  },
  "05/09/2019": {
    "data": [
      {
        "id": 40260,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40263,
        "name": "VIP",
        "event_name": "Cannabition - Sep 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64443
  },
  "06/09/2019": {
    "data": [
      {
        "id": 40266,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40269,
        "name": "VIP",
        "event_name": "Cannabition - Sep 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64446
  },
  "07/09/2019": {
    "data": [
      {
        "id": 40272,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40275,
        "name": "VIP",
        "event_name": "Cannabition - Sep 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64449
  },
  "08/09/2019": {
    "data": [
      {
        "id": 40278,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40281,
        "name": "VIP",
        "event_name": "Cannabition - Sep 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64452
  },
  "09/09/2019": {
    "data": [
      {
        "id": 40284,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40287,
        "name": "VIP",
        "event_name": "Cannabition - Sep 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64455
  },
  "10/09/2019": {
    "data": [
      {
        "id": 40290,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40293,
        "name": "VIP",
        "event_name": "Cannabition - Sep 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64458
  },
  "11/09/2019": {
    "data": [
      {
        "id": 40296,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40299,
        "name": "VIP",
        "event_name": "Cannabition - Sep 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64461
  },
  "12/09/2019": {
    "data": [
      {
        "id": 40302,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40305,
        "name": "VIP",
        "event_name": "Cannabition - Sep 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64464
  },
  "13/09/2019": {
    "data": [
      {
        "id": 40308,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40311,
        "name": "VIP",
        "event_name": "Cannabition - Sep 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64467
  },
  "14/09/2019": {
    "data": [
      {
        "id": 40314,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40317,
        "name": "VIP",
        "event_name": "Cannabition - Sep 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64470
  },
  "15/09/2019": {
    "data": [
      {
        "id": 40320,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40323,
        "name": "VIP",
        "event_name": "Cannabition - Sep 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64473
  },
  "16/09/2019": {
    "data": [
      {
        "id": 40326,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40329,
        "name": "VIP",
        "event_name": "Cannabition - Sep 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64476
  },
  "17/09/2019": {
    "data": [
      {
        "id": 40332,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40335,
        "name": "VIP",
        "event_name": "Cannabition - Sep 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64479
  },
  "18/09/2019": {
    "data": [
      {
        "id": 40338,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 18",
        "sales_channel": "all",
        "sold_out_percentage": 0.95,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40341,
        "name": "VIP",
        "event_name": "Cannabition - Sep 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64482
  },
  "19/09/2019": {
    "data": [
      {
        "id": 40344,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40347,
        "name": "VIP",
        "event_name": "Cannabition - Sep 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64485
  },
  "20/09/2019": {
    "data": [
      {
        "id": 40350,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40353,
        "name": "VIP",
        "event_name": "Cannabition - Sep 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64488
  },
  "21/09/2019": {
    "data": [
      {
        "id": 40356,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40359,
        "name": "VIP",
        "event_name": "Cannabition - Sep 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64491
  },
  "22/09/2019": {
    "data": [
      {
        "id": 40362,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40365,
        "name": "VIP",
        "event_name": "Cannabition - Sep 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64494
  },
  "23/09/2019": {
    "data": [
      {
        "id": 40368,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40371,
        "name": "VIP",
        "event_name": "Cannabition - Sep 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64497
  },
  "24/09/2019": {
    "data": [
      {
        "id": 40374,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40377,
        "name": "VIP",
        "event_name": "Cannabition - Sep 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64500
  },
  "25/09/2019": {
    "data": [
      {
        "id": 40380,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40383,
        "name": "VIP",
        "event_name": "Cannabition - Sep 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64503
  },
  "26/09/2019": {
    "data": [
      {
        "id": 40386,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40389,
        "name": "VIP",
        "event_name": "Cannabition - Sep 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64506
  },
  "27/09/2019": {
    "data": [
      {
        "id": 40392,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40395,
        "name": "VIP",
        "event_name": "Cannabition - Sep 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64509
  },
  "28/09/2019": {
    "data": [
      {
        "id": 40398,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40401,
        "name": "VIP",
        "event_name": "Cannabition - Sep 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64512
  },
  "29/09/2019": {
    "data": [
      {
        "id": 40404,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40407,
        "name": "VIP",
        "event_name": "Cannabition - Sep 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64515
  },
  "30/09/2019": {
    "data": [
      {
        "id": 40410,
        "name": "General Admission",
        "event_name": "Cannabition - Sep 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40413,
        "name": "VIP",
        "event_name": "Cannabition - Sep 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64518
  },
  "01/10/2019": {
    "data": [
      {
        "id": 40416,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40419,
        "name": "VIP",
        "event_name": "Cannabition - Oct 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64521
  },
  "02/10/2019": {
    "data": [
      {
        "id": 40422,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40425,
        "name": "VIP",
        "event_name": "Cannabition - Oct 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64524
  },
  "03/10/2019": {
    "data": [
      {
        "id": 40428,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40431,
        "name": "VIP",
        "event_name": "Cannabition - Oct 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64527
  },
  "04/10/2019": {
    "data": [
      {
        "id": 40434,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40437,
        "name": "VIP",
        "event_name": "Cannabition - Oct 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64530
  },
  "05/10/2019": {
    "data": [
      {
        "id": 40440,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40443,
        "name": "VIP",
        "event_name": "Cannabition - Oct 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64533
  },
  "06/10/2019": {
    "data": [
      {
        "id": 40446,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40449,
        "name": "VIP",
        "event_name": "Cannabition - Oct 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64536
  },
  "07/10/2019": {
    "data": [
      {
        "id": 40452,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40455,
        "name": "VIP",
        "event_name": "Cannabition - Oct 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64539
  },
  "08/10/2019": {
    "data": [
      {
        "id": 40458,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40461,
        "name": "VIP",
        "event_name": "Cannabition - Oct 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64542
  },
  "09/10/2019": {
    "data": [
      {
        "id": 40464,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40467,
        "name": "VIP",
        "event_name": "Cannabition - Oct 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64545
  },
  "10/10/2019": {
    "data": [
      {
        "id": 40470,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40473,
        "name": "VIP",
        "event_name": "Cannabition - Oct 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64548
  },
  "11/10/2019": {
    "data": [
      {
        "id": 40476,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40479,
        "name": "VIP",
        "event_name": "Cannabition - Oct 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64551
  },
  "12/10/2019": {
    "data": [
      {
        "id": 40482,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40485,
        "name": "VIP",
        "event_name": "Cannabition - Oct 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64554
  },
  "13/10/2019": {
    "data": [
      {
        "id": 40488,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40491,
        "name": "VIP",
        "event_name": "Cannabition - Oct 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64557
  },
  "14/10/2019": {
    "data": [
      {
        "id": 40494,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40497,
        "name": "VIP",
        "event_name": "Cannabition - Oct 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64560
  },
  "15/10/2019": {
    "data": [
      {
        "id": 40500,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40503,
        "name": "VIP",
        "event_name": "Cannabition - Oct 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64563
  },
  "16/10/2019": {
    "data": [
      {
        "id": 40506,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40509,
        "name": "VIP",
        "event_name": "Cannabition - Oct 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64566
  },
  "17/10/2019": {
    "data": [
      {
        "id": 40512,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40515,
        "name": "VIP",
        "event_name": "Cannabition - Oct 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64569
  },
  "18/10/2019": {
    "data": [
      {
        "id": 40518,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40521,
        "name": "VIP",
        "event_name": "Cannabition - Oct 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64572
  },
  "19/10/2019": {
    "data": [
      {
        "id": 40524,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40527,
        "name": "VIP",
        "event_name": "Cannabition - Oct 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64575
  },
  "20/10/2019": {
    "data": [
      {
        "id": 40530,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40533,
        "name": "VIP",
        "event_name": "Cannabition - Oct 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64578
  },
  "21/10/2019": {
    "data": [
      {
        "id": 40536,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40539,
        "name": "VIP",
        "event_name": "Cannabition - Oct 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64581
  },
  "22/10/2019": {
    "data": [
      {
        "id": 40542,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40545,
        "name": "VIP",
        "event_name": "Cannabition - Oct 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64584
  },
  "23/10/2019": {
    "data": [
      {
        "id": 40548,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40551,
        "name": "VIP",
        "event_name": "Cannabition - Oct 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64587
  },
  "24/10/2019": {
    "data": [
      {
        "id": 40554,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40557,
        "name": "VIP",
        "event_name": "Cannabition - Oct 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64590
  },
  "25/10/2019": {
    "data": [
      {
        "id": 40560,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40563,
        "name": "VIP",
        "event_name": "Cannabition - Oct 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64593
  },
  "26/10/2019": {
    "data": [
      {
        "id": 40566,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40569,
        "name": "VIP",
        "event_name": "Cannabition - Oct 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64596
  },
  "27/10/2019": {
    "data": [
      {
        "id": 40572,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40575,
        "name": "VIP",
        "event_name": "Cannabition - Oct 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64599
  },
  "28/10/2019": {
    "data": [
      {
        "id": 40578,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40581,
        "name": "VIP",
        "event_name": "Cannabition - Oct 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64602
  },
  "29/10/2019": {
    "data": [
      {
        "id": 40584,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40587,
        "name": "VIP",
        "event_name": "Cannabition - Oct 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64605
  },
  "30/10/2019": {
    "data": [
      {
        "id": 40590,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40593,
        "name": "VIP",
        "event_name": "Cannabition - Oct 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64608
  },
  "31/10/2019": {
    "data": [
      {
        "id": 40596,
        "name": "General Admission",
        "event_name": "Cannabition - Oct 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40599,
        "name": "VIP",
        "event_name": "Cannabition - Oct 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64611
  },
  "01/11/2019": {
    "data": [
      {
        "id": 40602,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40605,
        "name": "VIP",
        "event_name": "Cannabition - Nov 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64614
  },
  "02/11/2019": {
    "data": [
      {
        "id": 40608,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40611,
        "name": "VIP",
        "event_name": "Cannabition - Nov 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64617
  },
  "03/11/2019": {
    "data": [
      {
        "id": 40614,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40617,
        "name": "VIP",
        "event_name": "Cannabition - Nov 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64620
  },
  "04/11/2019": {
    "data": [
      {
        "id": 40620,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40623,
        "name": "VIP",
        "event_name": "Cannabition - Nov 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64623
  },
  "05/11/2019": {
    "data": [
      {
        "id": 40626,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40629,
        "name": "VIP",
        "event_name": "Cannabition - Nov 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64626
  },
  "06/11/2019": {
    "data": [
      {
        "id": 40632,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40635,
        "name": "VIP",
        "event_name": "Cannabition - Nov 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64629
  },
  "07/11/2019": {
    "data": [
      {
        "id": 40638,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40641,
        "name": "VIP",
        "event_name": "Cannabition - Nov 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64632
  },
  "08/11/2019": {
    "data": [
      {
        "id": 40644,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40647,
        "name": "VIP",
        "event_name": "Cannabition - Nov 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64635
  },
  "09/11/2019": {
    "data": [
      {
        "id": 40650,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40653,
        "name": "VIP",
        "event_name": "Cannabition - Nov 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64638
  },
  "10/11/2019": {
    "data": [
      {
        "id": 40656,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40659,
        "name": "VIP",
        "event_name": "Cannabition - Nov 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64641
  },
  "11/11/2019": {
    "data": [
      {
        "id": 40662,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40665,
        "name": "VIP",
        "event_name": "Cannabition - Nov 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64644
  },
  "12/11/2019": {
    "data": [
      {
        "id": 40668,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40671,
        "name": "VIP",
        "event_name": "Cannabition - Nov 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64647
  },
  "13/11/2019": {
    "data": [
      {
        "id": 40674,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40677,
        "name": "VIP",
        "event_name": "Cannabition - Nov 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64650
  },
  "14/11/2019": {
    "data": [
      {
        "id": 40680,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40683,
        "name": "VIP",
        "event_name": "Cannabition - Nov 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64653
  },
  "15/11/2019": {
    "data": [
      {
        "id": 40686,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40689,
        "name": "VIP",
        "event_name": "Cannabition - Nov 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64656
  },
  "16/11/2019": {
    "data": [
      {
        "id": 40692,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40695,
        "name": "VIP",
        "event_name": "Cannabition - Nov 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64659
  },
  "17/11/2019": {
    "data": [
      {
        "id": 40698,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40701,
        "name": "VIP",
        "event_name": "Cannabition - Nov 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64662
  },
  "18/11/2019": {
    "data": [
      {
        "id": 40704,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40707,
        "name": "VIP",
        "event_name": "Cannabition - Nov 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64665
  },
  "19/11/2019": {
    "data": [
      {
        "id": 40710,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40713,
        "name": "VIP",
        "event_name": "Cannabition - Nov 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64668
  },
  "20/11/2019": {
    "data": [
      {
        "id": 40716,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40719,
        "name": "VIP",
        "event_name": "Cannabition - Nov 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64671
  },
  "21/11/2019": {
    "data": [
      {
        "id": 40722,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40725,
        "name": "VIP",
        "event_name": "Cannabition - Nov 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64674
  },
  "22/11/2019": {
    "data": [
      {
        "id": 40728,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40731,
        "name": "VIP",
        "event_name": "Cannabition - Nov 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64677
  },
  "23/11/2019": {
    "data": [
      {
        "id": 40734,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40737,
        "name": "VIP",
        "event_name": "Cannabition - Nov 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64680
  },
  "24/11/2019": {
    "data": [
      {
        "id": 40740,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40743,
        "name": "VIP",
        "event_name": "Cannabition - Nov 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64683
  },
  "25/11/2019": {
    "data": [
      {
        "id": 40746,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40749,
        "name": "VIP",
        "event_name": "Cannabition - Nov 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64686
  },
  "26/11/2019": {
    "data": [
      {
        "id": 40752,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40755,
        "name": "VIP",
        "event_name": "Cannabition - Nov 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64689
  },
  "27/11/2019": {
    "data": [
      {
        "id": 40758,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40761,
        "name": "VIP",
        "event_name": "Cannabition - Nov 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64692
  },
  "28/11/2019": {
    "data": [
      {
        "id": 40764,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40767,
        "name": "VIP",
        "event_name": "Cannabition - Nov 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64695
  },
  "29/11/2019": {
    "data": [
      {
        "id": 40770,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40773,
        "name": "VIP",
        "event_name": "Cannabition - Nov 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64698
  },
  "30/11/2019": {
    "data": [
      {
        "id": 40776,
        "name": "General Admission",
        "event_name": "Cannabition - Nov 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40779,
        "name": "VIP",
        "event_name": "Cannabition - Nov 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64701
  },
  "01/12/2019": {
    "data": [
      {
        "id": 40782,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40785,
        "name": "VIP",
        "event_name": "Cannabition - Dec 1",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64704
  },
  "02/12/2019": {
    "data": [
      {
        "id": 40788,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40791,
        "name": "VIP",
        "event_name": "Cannabition - Dec 2",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64707
  },
  "03/12/2019": {
    "data": [
      {
        "id": 40794,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40797,
        "name": "VIP",
        "event_name": "Cannabition - Dec 3",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64710
  },
  "04/12/2019": {
    "data": [
      {
        "id": 40800,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40803,
        "name": "VIP",
        "event_name": "Cannabition - Dec 4",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64713
  },
  "05/12/2019": {
    "data": [
      {
        "id": 40806,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40809,
        "name": "VIP",
        "event_name": "Cannabition - Dec 5",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64716
  },
  "06/12/2019": {
    "data": [
      {
        "id": 40812,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40815,
        "name": "VIP",
        "event_name": "Cannabition - Dec 6",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64719
  },
  "07/12/2019": {
    "data": [
      {
        "id": 40818,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40821,
        "name": "VIP",
        "event_name": "Cannabition - Dec 7",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64722
  },
  "08/12/2019": {
    "data": [
      {
        "id": 40824,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40827,
        "name": "VIP",
        "event_name": "Cannabition - Dec 8",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64725
  },
  "09/12/2019": {
    "data": [
      {
        "id": 40830,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40833,
        "name": "VIP",
        "event_name": "Cannabition - Dec 9",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64728
  },
  "10/12/2019": {
    "data": [
      {
        "id": 40836,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40839,
        "name": "VIP",
        "event_name": "Cannabition - Dec 10",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64731
  },
  "11/12/2019": {
    "data": [
      {
        "id": 40842,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40845,
        "name": "VIP",
        "event_name": "Cannabition - Dec 11",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64734
  },
  "12/12/2019": {
    "data": [
      {
        "id": 40848,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40851,
        "name": "VIP",
        "event_name": "Cannabition - Dec 12",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64737
  },
  "13/12/2019": {
    "data": [
      {
        "id": 40854,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40857,
        "name": "VIP",
        "event_name": "Cannabition - Dec 13",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64740
  },
  "14/12/2019": {
    "data": [
      {
        "id": 40860,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40863,
        "name": "VIP",
        "event_name": "Cannabition - Dec 14",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64743
  },
  "15/12/2019": {
    "data": [
      {
        "id": 40866,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40869,
        "name": "VIP",
        "event_name": "Cannabition - Dec 15",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64746
  },
  "16/12/2019": {
    "data": [
      {
        "id": 40872,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40875,
        "name": "VIP",
        "event_name": "Cannabition - Dec 16",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64749
  },
  "17/12/2019": {
    "data": [
      {
        "id": 40878,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40881,
        "name": "VIP",
        "event_name": "Cannabition - Dec 17",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64752
  },
  "18/12/2019": {
    "data": [
      {
        "id": 40884,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40887,
        "name": "VIP",
        "event_name": "Cannabition - Dec 18",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64755
  },
  "19/12/2019": {
    "data": [
      {
        "id": 40890,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40893,
        "name": "VIP",
        "event_name": "Cannabition - Dec 19",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64758
  },
  "20/12/2019": {
    "data": [
      {
        "id": 40896,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40899,
        "name": "VIP",
        "event_name": "Cannabition - Dec 20",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64761
  },
  "21/12/2019": {
    "data": [
      {
        "id": 40902,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40905,
        "name": "VIP",
        "event_name": "Cannabition - Dec 21",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64764
  },
  "22/12/2019": {
    "data": [
      {
        "id": 40908,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40911,
        "name": "VIP",
        "event_name": "Cannabition - Dec 22",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64767
  },
  "23/12/2019": {
    "data": [
      {
        "id": 40914,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40917,
        "name": "VIP",
        "event_name": "Cannabition - Dec 23",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64770
  },
  "24/12/2019": {
    "data": [
      {
        "id": 40920,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40923,
        "name": "VIP",
        "event_name": "Cannabition - Dec 24",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64773
  },
  "25/12/2019": {
    "data": [
      {
        "id": 40926,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40929,
        "name": "VIP",
        "event_name": "Cannabition - Dec 25",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64776
  },
  "26/12/2019": {
    "data": [
      {
        "id": 40932,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40935,
        "name": "VIP",
        "event_name": "Cannabition - Dec 26",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64779
  },
  "27/12/2019": {
    "data": [
      {
        "id": 40938,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40941,
        "name": "VIP",
        "event_name": "Cannabition - Dec 27",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64782
  },
  "28/12/2019": {
    "data": [
      {
        "id": 40944,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40947,
        "name": "VIP",
        "event_name": "Cannabition - Dec 28",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64785
  },
  "29/12/2019": {
    "data": [
      {
        "id": 40950,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40953,
        "name": "VIP",
        "event_name": "Cannabition - Dec 29",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64788
  },
  "30/12/2019": {
    "data": [
      {
        "id": 40956,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40959,
        "name": "VIP",
        "event_name": "Cannabition - Dec 30",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64791
  },
  "31/12/2019": {
    "data": [
      {
        "id": 40962,
        "name": "General Admission",
        "event_name": "Cannabition - Dec 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      },
      {
        "id": 40965,
        "name": "VIP",
        "event_name": "Cannabition - Dec 31",
        "sales_channel": "all",
        "sold_out_percentage": 0,
        "timeslotTimes": {
          "data": []
        }
      }
    ],
    "id": 64794
  }
}